import gql from 'graphql-tag'
import {
    appstoreItem,
    appstoreItemResponse,
    learningItem,
    learningItemResponse,
} from './queryFields'

// Query
export function getAppstores() {
    return gql(`query {
        appstores {
            ${appstoreItem}
        }
    }`)
}

export function getAppstore(appId: string) {
    return gql(`query {
        appstore(id: ${appId}) {
            ${appstoreItemResponse}
        }
    }`)
}

export function getLearnings() {
    return gql(`query {
        learnings {
            ${learningItem}
        }
    }`)
}

export function getLearning(learningId: string) {
    return gql(`query {
        learning(id: ${learningId}) {
            ${learningItemResponse}
        }
    }`)
}
// Query end

// Mutation
// Mutation end
